import template from './createNewFileModal.html';
import controller from './createNewFileModalCtrl';
import './style.scss';

export default {
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    modalInstance: '<',
    familyId: '<',
    allocatedAdviserId: '<',
    personIds: '<',
    isClient: '<',
    factFindEnabled: '<',
    theme: '<',
    disableRouting: '<',
  },
};
